import React from "react";
import { ScrollView, View, Text, StyleSheet, Image } from "react-native";

import {
  GTAmericaCompressed,
  greenBrand,
  blackBrand,
  TrailersDemiBold,
  PanamaBold,
  GTAmerica,
} from "../libs/constants";
import { CuratorHeader } from "../components/curator/CuratorHeader";
import { PhoneNumberSignupForm } from "../components/forms/PhoneNumberSignupForm";
import { EventSlice } from "../components/events/EventSlice";
import { RouteComponentProps } from "../navigation";
import { useEffect } from "react";
import { mdBreakpoint } from "../constants";
import { useDimensions } from "../context/DimensionsContext";
import { HoverableLink } from "../components/common/HoverableLink";
import { useThemeState } from "../context/ThemeContext";
import { H1, P } from "@expo/html-elements";
import { TextureUvs } from "pixi.js";

interface Props { }

export const EventsLandingScreen: React.FC<
  RouteComponentProps<{
    isSmsSubscriber: string;
  }>
> = (props: RouteComponentProps<{ isSmsSubscriber: string }>) => {
  document.title = "Events | Happy Medium";
  const scrollRef = React.useRef(null);
  const { width } = useDimensions();
  const { theme } = useThemeState();
  const {
    match: {
      params: { isSmsSubscriber },
    },
  } = props;

  const subscribed = isSmsSubscriber === "subscribed";
  console.log(
    "SMS??",
    isSmsSubscriber,
    isSmsSubscriber === "subscribed",
    subscribed
  );
  const measuringTape = require("@happymedium/components/assets/images/blue-white-measure-tape-long-horizontal.png");
  const styles = StyleSheet.create({
    infoText: {
      fontFamily: GTAmericaCompressed,
      fontWeight: "300",
      fontSize: 24,
      color: blackBrand,
    },
    body: {
      color: theme.foregroundColor,
      fontFamily: GTAmerica,
      fontSize: width < mdBreakpoint ? 14 : 16,
    },
  });

  const mobileEventHeight = 740;
  const desktopEventHeight = 480;

  useEffect(() => {
    if (subscribed) {
      //@ts-ignore
      scrollRef.current!.scrollTo({
        y:
          width < mdBreakpoint
            ? mobileEventHeight * 9.45
            : desktopEventHeight * 9.74,
      });
    }
  }, []);

  return (
    <ScrollView
      style={{
        flex: 1,
        backgroundColor: theme.backgroundColor,
      }}
      ref={scrollRef}
    >
      <CuratorHeader
      // backgroundColor={greenBrand}
      // hideThemePicker={true}
      // logoColor={'black'}
      // linkColor={blackBrand}
      // isRow={true}
      />
      <View
        style={{
          maxWidth: width < mdBreakpoint ? "90%" : 540,
          marginTop: width < mdBreakpoint ? 20 : 60,
          alignSelf: "center",
          alignItems: "flex-start",
          // paddingLeft: 20,
          // paddingRight: 20,
          backgroundColor: theme.backgroundColor,
        }}
      >
        <H1
          style={{
            color: theme.foregroundColor,
            fontFamily: PanamaBold,
            fontWeight: "normal",
            fontSize: width < mdBreakpoint ? 24 : 38,
            letterSpacing: 1.2,
            width: "100%",
            textTransform: "uppercase",
            alignSelf: "flex-start",
          }}
        >
          Classes & Figure Drawing
        </H1>
        {/* <View style={{ height: 20 }} /> */}
        <Text style={[styles.body]}>
          Happy Medium's events are designed for the adult beginner who wants to
          have fun creating instead of consuming for a few hours with zero
          expectation of being "good enough." To learn more, check out our{" "}
          <HoverableLink
            linkUrl="/events/faq"
            linkType="internal"
            textStyle={{ alignSelf: "center" }}
          >
            <Text style={[styles.body]}>event FAQs</Text>
          </HoverableLink>
          .
          <P style={[styles.body, { fontSize: 14, fontWeight: "bold" }]}>
            **We are unable to accomodate refunds on ticket purchases. You must
            notify us at reservations@happy-medium.co at least 24 hours before
            your time slot in order to be eligible to reschedule. Otherwise, the
            full price will be forfeit.**
          </P>
          {`\n\n`}
          Check out our guide to an evening of figure drawing{" "}
          <HoverableLink
            linkUrl="/events/figure-drawing"
            linkType="internal"
            textStyle={{ alignSelf: "center" }}
          >
            <Text style={[styles.body]}>here</Text>
          </HoverableLink>
          !
        </Text>
      </View>
      {!subscribed && (
        <>
          <View style={{ height: 20 }} />
          <View
            style={{
              backgroundColor: theme.foregroundColor,
              paddingTop: 20,
              paddingBottom: 30,
              width: "100vw",
              maxWidth: 584,
              alignSelf: "center",
            }}
          >
            <Text
              style={[
                styles.infoText,
                {
                  fontSize: 22,
                  fontFamily: TrailersDemiBold,
                  textTransform: "uppercase",
                  letterSpacing: 1.4,
                  textAlign: "center",
                  color: theme.backgroundColor,
                },
              ]}
            >
              Sign up to be the first to know about new events
            </Text>
            <View style={{ alignItems: "center", marginTop: 5 }}>
              <PhoneNumberSignupForm />
            </View>
          </View>
        </>
      )}
      <View style={{ width: 30, height: 40 }} />
      <View />

      <EventSlice
        eventTitle="Sgraffito Summer Camp"
        eventDate="July 14th, 16th, 21st, & 23rd, 2025"
        eventTime="6:30pm - 8:30pm"
        eventImgUrl="https://49market.s3.amazonaws.com/Scraffito.png"
        eventSubtitle="with Team HM"
        eventUrl="/event/252"
        soldOut={true}
        ticketUrl="https://buy.stripe.com/cNidRbcfe9sRcJgcNq9R61h"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Figure Drawing in the Garden"
        eventDate="Monday, July 21st, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-07-21-figure-drawing.png"
        eventSubtitle="with special guest, Laura."
        eventUrl="/event/252"
        soldOut={true}
        ticketUrl="https://buy.stripe.com/6oUaEZ7ZOfxyfdM9C85kk03"
        location="224 Franklin St, Brooklyn, NY 11222"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Tuesday, July 22nd, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-07-22-figure-drawing.png"
        eventSubtitle="with special guest, Shea."
        eventUrl="/event/252"
        soldOut={true}
        ticketUrl="https://buy.stripe.com/7sY4gB1AAdJ74cK14I9R608"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="The Art of the Prospect Park Carousel"
        eventDate="Thursday, July 24th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-07-24-carousel.png"
        eventSubtitle=""
        eventUrl="/event/252"
        soldOut={true}
        ticketUrl="https://buy.stripe.com/6oUbJ21fdee8b2W3vC40526"
        location="Prospect Park Carousel"
      />
      <EventSlice
        eventTitle="Build-a-Lamp"
        eventDate="Sunday, July 27th, 2025"
        eventTime="9:00am - 11:00am"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-07-27-Lamp.png"
        eventSubtitle="with Team HM"
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/eVq28tcom0PDblS7gxd3i01"
        location="224 Franklin St, Brooklyn, NY 11222"
      />
      <EventSlice
        eventTitle="Figure Drawing in the Garden"
        eventDate="Monday, July 28th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-07-28-figure-drawing.png"
        eventSubtitle="with special guest, Lauren Gerrie."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/28E9AVbc0712e9Ig0w5kk04"
        location="224 Franklin St, Brooklyn, NY 11222"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Tuesday, July 29th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-07-29-figure-drawing.png"
        eventSubtitle="with special guest, Shea."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/9B65kF0ww0WldNkcNq9R609"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Celebrating Architecture at the Woolworth Building"
        eventDate="Wednesday, July 30th, 2025"
        eventTime="6:00pm - 8:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-07-30-woolworth.png"
        eventSubtitle=""
        eventUrl="/event/252"
        soldOut={true}
        ticketUrl="https://buy.stripe.com/dRm7sM1fdda4b2Wfek40527"
        location="The Woolworth Building"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Wednesday, July 30th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-07-30-figure-drawing.png"
        eventSubtitle="with special guest, Tommi."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/28E00lbbaawVeRodRu9R60a"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Figure Drawing in the Garden"
        eventDate="Monday, August 4th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-04-figure-drawing.png"
        eventSubtitle="with special guest, Ume."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/5kQ00lcg4dpq5Dc29G5kk08"
        location="224 Franklin St, Brooklyn, NY 11222"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Tuesday, August 5th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-05-figure-drawing.png"
        eventSubtitle="with special guest, Bola Bee."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/7sYaEZenmeNbcJg3cQ9R61w"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Wednesday, August 6th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-06-figure-drawing.png"
        eventSubtitle="with special guest, Ume."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/3cIeVf6UUawVbFc4gU9R61x"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="The Art of Crochet"
        eventDate="Saturday, August 9th, 2025"
        eventTime="9:00am - 11:00am"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-09-crochet.png"
        eventSubtitle="with Team HM"
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/9B67sN1AAeNbeRocNq9R61E"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Figure Drawing in the Garden"
        eventDate="Monday, August 11th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-11-figure-drawing.png"
        eventSubtitle="with special guest, Shea."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/aFabJ3dk80CEghQ3dK5kk09"
        location="224 Franklin St, Brooklyn, NY 11222"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Tuesday, August 12th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-12-figure-drawing.png"
        eventSubtitle="with special guest, Laura."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/5kQ5kFbbaawVcJgeVy9R61z"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Wednesday, August 13th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-13-figure-drawing.png"
        eventSubtitle="with special guest, Tommi."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/cNi6oJ4MMgVj10y7t69R61C"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Build-a-Lamp"
        eventDate="Saturday, August 16th, 2025"
        eventTime="9:00am - 11:00am"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-16-Lamp.png"
        eventSubtitle="with Team HM"
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/7sY14p886fKx61y30hd3i0g"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="The Art of Watercolor: Garden Painting"
        eventDate="Saturday, August 16th, 2025"
        eventTime="9:00am - 11:00am"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-16-Watercolor-In-The-Garden.png"
        eventSubtitle="with Claire Wilson-Oghedo"
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/14A00l4NC99a5Dc15C5kk0c"
        location="224 Franklin St, Brooklyn, NY 11222"
      />
      <EventSlice
        eventTitle="Paint Like M*tisse"
        eventDate="Sunday, August 17th, 2025"
        eventTime="9:00am - 11:00am"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-17-Matisse.png"
        eventSubtitle="with Tayler Carraway"
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/4gM14penm48x7oW00E9R61G"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Build-a-Lamp"
        eventDate="Sunday, August 17th, 2025"
        eventTime="9:00am - 11:00am"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-17-Lamp.png"
        eventSubtitle="with Team HM"
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/aFa3cx4VU9m94XufN3d3i0f"
        location="224 Franklin St, Brooklyn, NY 11222"
      />
      <EventSlice
        eventTitle="Sgraffito Summer Camp"
        eventDate="August 18th, 20th, 25th, & 27th, 2025"
        eventTime="6:30pm - 8:30pm"
        eventImgUrl="https://49market.s3.amazonaws.com/SgraffitoAugust.png"
        eventSubtitle="with Team HM"
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/7sYeVf5QQ20p5gO4gU9R61H"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Figure Drawing in the Garden"
        eventDate="Monday, August 18th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-18-figure-drawing.png"
        eventSubtitle="with special guest, Lauren Gerrie."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/aFa4gBgwk99a7Lk01y5kk0b"
        location="224 Franklin St, Brooklyn, NY 11222"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Tuesday, August 19th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-19-figure-drawing.png"
        eventSubtitle="with special guest, Shea."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/9B64gB1AA20p8t028M9R61A"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Wednesday, August 20th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-20-figure-drawing.png"
        eventSubtitle="with special guest, Merray."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/8x27sN1AAeNbeRoaFi9R61B"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="The Art of the Prospect Park Carousel"
        eventDate="Thursday, August 21st, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.us-east-1.amazonaws.com/carousel-august.png"
        eventSubtitle=""
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/dRm9AU0b96LG4Eyeag4052c"
        location="Prospect Park Carousel"
      />
      <EventSlice
        eventTitle="The Art of Watercolor: Garden Painting"
        eventDate="Saturday, August 23rd, 2025"
        eventTime="9:00am - 11:00am"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-23-watercolor-still-life.png"
        eventSubtitle="with Claire Wilson-Oghedo"
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/8x27sN0ww7kJ6kS4gU9R61F"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Figure Drawing in the Garden"
        eventDate="Monday, August 25th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-25-figure-drawing.png"
        eventSubtitle="with special guest, Laura."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/fZu4gB7ZO0CEc1AdSo5kk0a"
        location="224 Franklin St, Brooklyn, NY 11222"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Tuesday, August 26th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-26-figure-drawing.png"
        eventSubtitle="with special guest, Bola Bee."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/14A14pbbadJ78t000E9R61y"
        location="49 Market St, NY, NY 10002"
      />
      <EventSlice
        eventTitle="Figure Drawing"
        eventDate="Wednesday, August 27th, 2025"
        eventTime="7:00pm - 9:00pm"
        eventImgUrl="https://49market.s3.amazonaws.com/2025-08-27-figure-drawing.png"
        eventSubtitle="with special guest, Lauren Gerrie."
        eventUrl="/event/252"
        soldOut={false}
        ticketUrl="https://buy.stripe.com/3cI9AVenmbAZaB800E9R61D"
        location="49 Market St, NY, NY 10002"
      />
      <View style={{ height: 40 }} />
      <Image
        source={measuringTape}
        style={{
          height: 45,
          width: 450,
          maxWidth: "100vw",
          resizeMode: "contain",
          marginTop: 40,
          paddingBottom: 40,
          alignSelf: "center",
          transform: [{ rotate: "-10deg" }],
          left: 200,
        }}
      />
    </ScrollView>
  );
};

// <EventSlice
//         key={'AOPD_JUL312022'}
//         eventTitle="The Art of Plywood Design"
//         eventDate="Sunday, July 31st, 2022"
//         eventTime="10:00am - 2:00pm"
//         eventImgUrl="https://49market.s3.amazonaws.com/2022-07-31_art-of-plywood-design.png"
//         eventSubtitle="with Rett Carraway."
//         eventUrl="/event/208"
//         soldOut={false}
//         ticketUrl="https://buy.stripe.com/dR63fSd5i5662EodUt"
//       />
